// Common
import React from 'react';

// Moment
import moment from 'moment';
import 'moment/locale/ru';

// Data
// import data from './data/data'; // закоментил чтобы не вылетали варнинги
// import data_archive from './data/data_archive'; // закоментил чтобы не вылетали варнинги
import output from './data/output';
import ThreeDatePicker from './three_calendar';

// Ant
import { 
    Icon,
    Typography,
    Button,
    Modal,
} from 'antd';

const { Text } = Typography;
// const { Option } = Select;
const confirm = Modal.confirm;
// const Search = Input.Search;
// const InputGroup = Input.Group;
// const { RangePicker } = DatePicker;


moment.locale('ru');

class Output_Day extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sort_selected_days: {},
            data: {
                selected: []
            }
        }
    }

    componentDidUpdate(prevProps, prevState){
        console.log(this.state);
        // if(this.state.data.selected.length !== prevState.data.selected.length){
        //     console.log(this.state);
        // }
    }

    // Выбранные данные в календаре
    select_day_in_calendar = (days) => {


        var getProperty = function (propertyName) {
            return sort_selected_days[propertyName];
        };

        let sort_selected_days = this.state.sort_selected_days;

        if(days.length){
            days.forEach((item, index) => {
                let key = moment(item).year()+'_'+moment(item).format('MM');
                if(!getProperty(key)){
                    sort_selected_days[key] = [];
                }
                if(sort_selected_days[key].indexOf(moment(item).date()) < 0){
                    sort_selected_days[key].push(moment(item).date());
                }
            })
        }

        this.setState((state, props) => ({
            sort_selected_days: sort_selected_days,
            data: {
                ...state.data,
                selected: days
            }
        }))
    }

    // Сбросить выбранные даты
    reset_data_selected = () => {
        this.setState((state, props) => ({
            sort_selected_days: {},
            data: {
                ...state.data,
                selected: []
            }
        }))
    }

    // Спрятать не рабочие дни
    hide_drawer_output_day = () => {
        this.setState((state, props) => ({
            visible_output_day: false
        }))
    }

    // Удалить месяц в выбранных датах
    reset_selected_month = (item) => {
        let sort_selected_days = this.state.sort_selected_days,
            data_selected = this.state.data.selected;
        
            let array_data = item.split('_');
            let year = array_data[0];
            let month = array_data[1];
            let change_item = year+'-'+month;
            
            let change_data_selected = data_selected.filter(function(el){
                let slise_el = el.slice(0, -3);
                return slise_el !== change_item;
            });

        delete sort_selected_days[item];
        
        this.setState((state, props) => ({
            sort_selected_days: sort_selected_days,
            data: {
                ...state.data,
                selected: change_data_selected
            }
        }))
    }

    // Подтвердить выбранные нерабочие даты
    confirm_output_day = () => {
        confirm({
            title: 'Внимание',
            content: 'Вы действительно отметить выбранные дни (3) как нерабочие для данного водителя?',
            okText: "Отметить нерабочие дни",
            className: 'confirm-gray',
            cancelText: "Отмена",
            okType: 'primary',
            width: 432,
            cancelButtonProps: {
                width: 176,
                type: 'primary',
                ghost: true
            }
        });
    }

    render(){

        let selected_in_table = this.state.data.selected,
            excluded_ts_select = 'excluded-ts__select',
            sort_selected_days = this.state.sort_selected_days;

            if(selected_in_table && selected_in_table.length > 0){
                excluded_ts_select = 'excluded-ts__select active';
            }

        return (
            <div className="auto-order__wrap">
                <ThreeDatePicker type="output" orders={this.props.orders} output={output} select_days={this.select_day_in_calendar} selected_days={this.state.data.selected}/>
                <div className="auto-order__select-output block">
                    <div className="block__title">
                        Выберите на календаре дни, которые хотите отметить как нерабочие для данного водителя.
                    </div>
                    <div className="block__wrap">
                        <div className="auto-order__output-list">
                            {sort_selected_days !== {} && Object.keys(sort_selected_days).map((item, index) => {
                                let array_data = item.split('_');
                                let year = array_data[0];
                                let month = moment().month(array_data[1]).format('MMM');
                                let days = sort_selected_days[item].join(', ');
                                if(sort_selected_days[item].length > 0) {
                                    return (
                                        <div className="item" key={item}>
                                            <div className="item__date">{month} {year} <Button type="link" onClick={e => this.reset_selected_month(item)} className="button_reset">Сбросить</Button></div>
                                            <Text type="secondary">{days}</Text>
                                        </div>
                                    )
                                }
                                return null;
                            })}
                        </div>
                    </div>
                </div>
                <div className="auto-order__footer">
                    <div className="auto-order__footer-left">
                        <div className={excluded_ts_select}>
                            <div className="excluded-ts__select-count">
                                {selected_in_table && selected_in_table.length > 0 && (<Icon type="info" />)} Выбрано дней: {selected_in_table && selected_in_table.length}
                            </div>
                            {selected_in_table && selected_in_table.length > 0 && <Button onClick={this.reset_data_selected} className="excluded-ts__reset" type="link">Сбросить</Button>}
                        </div>
                    </div>
                    <div className="auto-order__footer-right">
                        <Button style={{ width: 176, marginRight: 16 }} onClick={this.hide_drawer_output_day} ghost type="primary">Отмена</Button>
                        <Button onClick={this.confirm_output_day} disabled={!selected_in_table.length} type="primary">Отметить нерабочие дни</Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Output_Day;